// add styles to vertically align button text if the site is loaded on any machine other than windows

jQuery(document).ready(function(){
    
    if (navigator.platform.indexOf('Win') === -1){
        jQuery("button, .monro-button, .appointment-button-wrapper h3, .learn-more-button").css({"padding-top": "4px"});
        jQuery(".offer-button-wrapper .monro-button").css({"padding-top": "12px"});
        jQuery("button, .monro-button, .appointment-button-wrapper h3, .learn-more-button").css({"padding-bottom": "0px"});
    }

});